var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-menu',{model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}}),_c('app-toolbar',{model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}}),_c('v-container',[_c('v-row',[_c('v-col',[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }